"use client";

import { useEffect, useState } from "react";

/**
 * Today at UTC midnight, computed on the CLIENT.
 *
 * Both deal date-picker modals derived this with a render-time
 * `useMemo(() => new Date(), [])`. They are mounted globally by
 * `DetailPageModals` in hub's root layout, so that memo ran on EVERY page —
 * including during a prerender, which `cacheComponents` rejects outright: the
 * prerendered HTML would bake in the build date and hand every visitor a
 * "today" that is however old the deploy is.
 *
 * Returns `undefined` until the effect runs. Callers should not render a
 * date picker before then — a picker anchored to a placeholder date is worse
 * than one that appears a frame later.
 */
export function useTodayUtcMidnight(): Date | undefined {
  const [today, setToday] = useState<Date | undefined>(undefined);

  useEffect(() => {
    const now = new Date();
    setToday(new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())));
  }, []);

  return today;
}
